import { useLibraryCrehanaAuthGetCentralizedDataQuery } from "./get-centralized-data.v5.generated";
export var useGetCentralizedSessionData = function useGetCentralizedSessionData(organizationSlug) {
  var _data$security$curren;
  var _useLibraryCrehanaAut = useLibraryCrehanaAuthGetCentralizedDataQuery({
      variables: {
        organization_slug: organizationSlug
      },
      context: {
        clientName: 'v5'
      }
    }),
    data = _useLibraryCrehanaAut.data,
    loading = _useLibraryCrehanaAut.loading,
    error = _useLibraryCrehanaAut.error;
  if (loading) {
    return {
      isCentralizedSuperAdmin: false,
      loading: true,
      error: undefined
    };
  }
  if (error) {
    return {
      isCentralizedSuperAdmin: false,
      loading: false,
      error: true
    };
  }
  var centralizedSession = data === null || data === void 0 ? void 0 : (_data$security$curren = data.security.current_session) === null || _data$security$curren === void 0 ? void 0 : _data$security$curren.centralized_session;
  var adminSlugs = centralizedSession === null || centralizedSession === void 0 ? void 0 : centralizedSession.centralized_admin_organization_slugs;
  if (!centralizedSession) {
    return {
      isCentralizedSuperAdmin: false,
      loading: false,
      error: undefined
    };
  }
  return {
    isCentralizedSuperAdmin: Boolean(adminSlugs === null || adminSlugs === void 0 ? void 0 : adminSlugs.length),
    loading: false,
    error: undefined
  };
};